"use strict";

document.addEventListener("DOMContentLoaded", () => {
    // let statsgridstats = document.getElementsByClassName('stats-grid-stat');
    // for (let y = 0; y < statsgridstats.length; y++) {
    //
    //     let numAnim = new countUp.CountUp(statsgridstats[y].id, statsgridstats[y].dataset.number, {
    //         enableScrollSpy: true,
    //         scrollSpyOnce: true,
    //         duration: 5,
    //     });
    //
    //     if (!countUp.error) {
    //         numAnim.start(function () {
    //             console.log('Animation finished ' + statsgridstats[y].id)
    //         });
    //         console.log(statsgridstats[y].id + ' started');
    //     } else {
    //         numAnim.error(numAnim.error);
    //     }
    // }
});

